import axios from 'axios'

// Default instance calling stapyt api

export let instance = axios.create({
  baseURL: process.env.VUE_APP_STAMPYT_API_HOST,
  timeout: 60000
})

instance.defaults.headers.common['x-api-key'] = process.env.VUE_APP_STAMPYT_API_KEY

instance.interceptors.response.use(
  (res) => {
    return res
  },
  (err) => {
    if (axios.isCancel(err)) {
      return { status: 100 }
    }
    if (err.code === 'ECONNABORTED') {
      return { status: 500 }
    } else {
      return err.response
    }
  }
)

export function tokenInterceptor(keycloak) {
  instance.interceptors.request.use(
    (config) => {
      const token = keycloak.token
      config.headers.Authorization = `Bearer ${token}`
      return config
    },
    (error) => {
      return Promise.reject(error)
    }
  )
}

// Instance of stampotheque V2
export let instanceStampotheque = axios.create({
  baseURL: process.env.VUE_APP_STAMPOTHEQUE_API_HOST,
  timeout: 60000
})

// Instance of Coveryt
export let instanceCoveryt = axios.create({
  baseURL: process.env.VUE_APP_STAMPYT_DEVELOPER_HOST,
  timeout: 60000
})

instanceCoveryt.defaults.headers.common['x-api-key'] = process.env.VUE_APP_STAMPYT_DEVELOPER_COVERYT_API_KEY

// Instance of Falyt
export let instanceFalyt = axios.create({
  baseURL: process.env.VUE_APP_STAMPYT_DEVELOPER_HOST,
  timeout: 60000
})

instanceFalyt.defaults.headers.common['x-api-key'] = process.env.VUE_APP_STAMPYT_DEVELOPER_FALYT_API_KEY

// Instance of ClippingPath (SAAS Détourage)
export let instanceClippingPath = axios.create({
  baseURL: process.env.VUE_APP_STAMPYT_CLIPPINGPATH_HOST,
  timeout: 60000,
  auth: {
    username: process.env.VUE_APP_STAMPYT_CLIPPINGPATH_USER,
    password: process.env.VUE_APP_STAMPYT_CLIPPINGPATH_PASSWORD
  }
})
